import { Selector } from "@reduxjs/toolkit";

import { ModelPath } from "@com.mgmtp.a12.base/base-model-api/lib/main/model";

import { ModulFState } from "../store";

export function getValidationCode(modelId: string): Selector<ModulFState, string | undefined> {
	return state => state.validation.validationCodes[modelId];
}
export function getValidationTargetFieldPaths({
	formModelId,
	screenPath
}: {
	formModelId: string;
	screenPath: ModelPath;
}): Selector<ModulFState, string[] | undefined> {
	return state =>
		state.validation.validationTargetFields[formModelId]
			? state.validation.validationTargetFields[formModelId][ModelPath.toString(screenPath)]
			: undefined;
}
